<template>
  <div class="directoryes">
    <div class="information_header">
      <h1>Справочник МКБ-11</h1>
    </div>
    <div class="directoryes_headline">
      <div class="directoryes_right">
        <div class="directoryes_search">
          <label for="search_name">Поиск по названию</label>
          <input
            id="search_name"
            v-model="search"
            class="directoryes_search-input"
          />
          <svg class="svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
          </svg>
        </div>
      </div>
    </div>
      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="list"
          :loading="loadingTable"
          loading-text="Данные загружаются..."
          :page="page"
          sort-by="Name"
          :items-per-page="itemsPerPage"
          :search="search"
          hide-default-footer
      >
        <template v-slot:[`header.name`]="{ header }">
            <span style="font-size: 14px">{{ header.text}}</span>
        </template>
        <template v-slot:[`header.code10`]="{ header }">
            <span style="font-size: 14px">{{ header.text}}</span>
        </template>
        <template v-slot:[`header.code`]="{ header }">
            <span style="font-size: 14px">{{ header.text}}</span>
        </template>
      <template v-slot:footer="{ props }">
              <div class="data-footer">
                  <div class="items-per-page">
                      <span>Строк на странице:</span>

                      <div class="items-per-page_item" :class="{active: itemsPerPage == 5}" @click.prevent="itemsPerPage = 5">
                          5
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == 10}" @click.prevent="itemsPerPage = 10">
                          10
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == 15}" @click.prevent="itemsPerPage = 15">
                          15
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == -1}" @click.prevent="itemsPerPage = -1">
                          все
                      </div>
                  </div>
                  <div class="pagination" v-if="itemsPerPage != -1">
                      <div class="pagination_prev" @click.prevent="page == 1 ? page : --page">
                          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
                          </svg>
                      </div>
                      <div class="pagination_number">
                          {{ props.pagination.pageStart + 1 }} - {{ props.pagination.pageStop }} из {{props.pagination.itemsLength}}
                      </div>
                      <div class="pagination_next" v-if="itemsPerPage" @click.prevent="page == props.pagination.pageCount ? page : ++page">
                          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
                          </svg>
                      </div>
                  </div>
              </div>
          </template>

          <v-progress-linear :active="loadingTable" :indeterminate="loadingTable" absolute bottom color="primary accent-4" ></v-progress-linear>
      </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import "../directory.scss";

export default {
  name: 'SprMkb10',
  computed: {
      ...mapGetters({
          apiGuide: 'apiGuide',
          apiUrl:'apiUrl'
      })
  },
  data: () => ({
      saveLoading: false,
      valid: false,
      loadingTable: false,
      list: [],
      headers: [
          { text: 'Наименование заболевания', value: 'name' },
          { text: 'Код МКБ-10', value: 'code10', width: 200},
          { text: 'Код МКБ-11', value: 'code' , width: 200},
      ],
      pagination: {
          sortBy: 'name'
      },
      page: 1,
      itemsPerPage: 10,
      search: '',
  }),
  methods:{
      sortArray(array, name){
          return array.sort((prev, next) => {
              const nameA = typeof prev[name] === 'string' ? prev[name].toUpperCase() : prev[name];
              const nameB = typeof next[name] === 'string' ? next[name].toUpperCase() : next[name];

              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
          })
      },
      get(){
          this.$http.get(`${this.apiGuide}api/SprMkb11/GetAll`)
          .then((res) => {
              this.list = this.sortArray(res.data, 'name');
              this.loadingTable = false;
            //   console.log(this.list);
          })
      }
  },
  created() {
     this.get();

  }
}
</script>
<style scoped>
  .svg {
      position: absolute;
      top: 30px;
      right: 10px;
    }
</style>
